namespace Gamification.Gamification {
    export class UtentiProdottiEditorColumns {
        static columnsKey = 'Gamification.UtentiProdottiEditor';
    }
}
